import { useMemo } from 'react';

type UseDemoContentLayoutProps = {
  windowOpen: boolean;
  isLeftPosition: boolean;
  panelOffset: number;
};

type UseDemoContentLayoutResult = {
  desktopOpenTransformX: string;
  mobileOpenTransformY: string;
  desktopMaxWidth: string;
};

const PANEL_WIDTH_PX = 380;
const PANEL_GAP_PX = 40;
const DESKTOP_PREVIEW_MIN_MARGIN_PX = 40;

export function useDemoContentLayout({
  windowOpen,
  isLeftPosition,
  panelOffset
}: UseDemoContentLayoutProps): UseDemoContentLayoutResult {
  return useMemo(() => {
    const panelShift = PANEL_WIDTH_PX + panelOffset + PANEL_GAP_PX;
    const desktopOpenTransformX = isLeftPosition
      ? `max(0px, calc(${panelShift}px - 50vw + 50%))`
      : `min(0px, calc(50vw - 50% - ${panelShift}px))`;
    const mobileOpenTransformY = 'calc(-50vh + 50%)';
    const desktopMaxWidth = windowOpen
      ? `max(0px, calc(100vw - ${panelShift + DESKTOP_PREVIEW_MIN_MARGIN_PX}px))`
      : `max(0px, calc(100vw - ${DESKTOP_PREVIEW_MIN_MARGIN_PX}px))`;

    return {
      desktopOpenTransformX,
      mobileOpenTransformY,
      desktopMaxWidth
    };
  }, [windowOpen, isLeftPosition, panelOffset]);
}
